import { Category, CategoryFull, FilterRanking } from "../Models";
import { APIURL } from "./config";

export const getRankType = async (token: string) => {
  const res = await fetch(`${APIURL}/Ranking/RankType`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json: { id: string; name: string }[] = await res.json();
  return json;
};

export const getCompaniesByRankType = async (
  rankTypeId: string,
  pageNumber: number = 1,
  pageSize: number = 100,
  sortBy: string = "",
  sortDesc: boolean = false,
  search: string = "",
  filterQuery: string = "",
  filters: FilterRanking[] = [],
  token: string
) => {
  const baseUrl = `${APIURL}/Ranking/Companies/${rankTypeId}`;
  const url = new URL(baseUrl);

  url.searchParams.append("pageNumber", pageNumber.toString());
  url.searchParams.append("pageSize", pageSize.toString());
  url.searchParams.append("sortBy", sortBy);
  url.searchParams.append("sortDesc", sortDesc.toString());
  url.searchParams.append("search", search);
  url.searchParams.append("filterQuery", filterQuery);
  let json;
  try {
    const res = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(filters),
    });
    json = await res.json();
  } catch (ex) {
    console.error(ex);
  }
  return json;
};

export const getUniversitiesByRankType = async (
  rankTypeId: string,
  pageNumber: number = 1,
  pageSize: number = 15,
  sortBy: string = "",
  sortDesc: boolean = false,
  search: string = "",
  filterQuery: string = "",
  filters: FilterRanking[] = [],
  token: string
) => {
  const baseUrl = `${APIURL}/Ranking/Unis/${rankTypeId}`;
  const url = new URL(baseUrl);

  url.searchParams.append("pageNumber", pageNumber.toString());
  url.searchParams.append("pageSize", pageSize.toString());
  url.searchParams.append("sortBy", sortBy);
  url.searchParams.append("sortDesc", sortDesc.toString());
  url.searchParams.append("search", search);
  url.searchParams.append("filterQuery", filterQuery);
  let json;
  try {
    const res = await fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(filters),
    });
    json = await res.json();
  } catch (ex) {
    console.error(ex);
  }

  return json;
};

export const postNewRankType = async (rankType: string, token: string) => {
  try {
    const res = await fetch(`${APIURL}/Ranking/RankType`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name: rankType }),
    });
    if (!res.ok) {
      throw new Error(`HTTP error status: ${res.status}`);
    }
  } catch (err) {
    return {
      error: true,
      message: "Rank type already exist",
    };
  }
};

export async function deleteRankType(rankTypeId: string, token: string) {
  await fetch(`${APIURL}/Ranking/RankType/${rankTypeId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}



export const updateRanking = async (
  tab: string,
  rankTypeId: string | undefined,
  id: string,
  categoryId: string,
  token: string
) => {
  if (tab === "Companies") {
    const res = await fetch(`${APIURL}/Ranking/Company`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        companyId: id,
        rankTypeId: rankTypeId,
        rankCategoryId: categoryId,
      }),
    });
    if (!res.ok) {
      const er = await res.text();
      throw new Error(er);
    }
  } else {
    const res = await fetch(`${APIURL}/Ranking/University`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        universityId: id,
        rankTypeId: rankTypeId,
        rankCategoryId: categoryId,
      }),
    });
    if (!res.ok) {
      const er = await res.text();
      throw new Error(er);
    }
  }
};

export const getCompanyRankingCategories = async (
  rankTypeId: string,
  token: string
) => {
  const res = await fetch(`${APIURL}/Ranking/Company/${rankTypeId}/Category`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json: CategoryFull[] = await res.json();
  return json;
};

export const getUniversityRankingCategories = async (
  rankTypeId: string,
  token: string
) => {
  const res = await fetch(
    `${APIURL}/Ranking/University/${rankTypeId}/Category`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const json: CategoryFull[] = await res.json();
  return json;
};

export const postRankingCategories = async (
  rankingCategory: Category,
  token: string
) => {
  const res = await fetch(`${APIURL}/Ranking/Category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(rankingCategory),
  });
  const json: CategoryFull = await res.json();
  return json;
};

export const updateRankingCategories = async (
  id: string,
  rankingCategory: Category,
  token: string
) => {
  const res = await fetch(`${APIURL}/Ranking/Category/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(rankingCategory),
  });
  if (res.ok) {
    const json: CategoryFull = await res.json();
    return json;
  } else {
    const er = await res.text();
    throw new Error(er);
  }
};

export const deleteRankingCategories = async (id: string, token: string) => {
  await fetch(`${APIURL}/Ranking/Category/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const searchCities = async (query: string, token: string) => {
  const res = await fetch(
    `${APIURL}/MasterData/CitySearch?query=${encodeURIComponent(query)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  if (!res.ok) {
    return [];
  }
  return await res.json();
};

export const editCompany = async (
  companyData: {
    id: string;
    name: string;
    url: string;
    linkedIn: string;
    cityIds: string[];
    revenue: string;
    stockMarket: string;
    relevance: string;
    hotStartup: string;
  },
  token: string
) => {
  const res = await fetch(`${APIURL}/Ranking/Company/Edit`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(companyData),
  });
  if (!res.ok) {
    const er = await res.text();
    throw new Error(er);
  }
  return await res.json();
};

export const editUniversity = async (
  universityData: {
    id: string;
    name: string;
    url: string;
    linkedIn: string;
    location: string;
    cityId: string | null;
    alternateNames: string;
    package: string;
    recruiters: string;
    degrees: string;
    abbreviation: string;
  },
  token: string
) => {
  const res = await fetch(`${APIURL}/Ranking/University/Edit`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(universityData),
  });
  if (!res.ok) {
    const er = await res.text();
    throw new Error(er);
  }
  return await res.json();
};
